export type PageToken = number | "ellipsis";

/**
 * 狭い画面向けのページ番号列。
 * 先頭・末尾と現在ページの前後を残し、間は省略記号にする。
 * 例: 8ページ中の5ページ目 → 1 … 4 5 6 … 8
 * 5ページ以下はそのまま並べる（省略しても幅がほとんど減らない）。
 */
export function windowedPageItems(current: number, total: number): PageToken[] {
  if (total <= 0) return [];
  const page = Math.min(Math.max(1, current), total);
  if (total <= 5) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const keep = new Set<number>([1, total]);
  for (let i = page - 1; i <= page + 1; i++) {
    if (i >= 1 && i <= total) keep.add(i);
  }
  // 端にいるときは窓を少し広げ、1 … 8 のように飛びすぎないようにする
  if (page <= 3) {
    keep.add(2);
    keep.add(3);
    keep.add(4);
  }
  if (page >= total - 2) {
    keep.add(total - 1);
    keep.add(total - 2);
    keep.add(total - 3);
  }

  const sorted = [...keep].filter((n) => n >= 1 && n <= total).sort((a, b) => a - b);
  const items: PageToken[] = [];
  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) items.push("ellipsis");
    items.push(sorted[i]);
  }
  return items;
}
